import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.object.assign.js";
import _isFunction from "lodash/isFunction";
import "core-js/modules/es.array.is-array.js";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Row, Col, CheckButton } from 'components/UI';
import { jsx as ___EmotionJSX } from "@emotion/react";

var CheckboxSwitch = function CheckboxSwitch(_ref) {
  var initialValue = _ref.value,
      label = _ref.label,
      fluid = _ref.fluid,
      onChange = _ref.onChange,
      formId = _ref.formId;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      value = _useState2[0],
      setValue = _useState2[1];

  var innerValue = formId ? initialValue : value;

  var handleChange = function handleChange() {
    if (!formId) setValue(function (prev) {
      return !prev;
    });
    _isFunction(onChange) && onChange(!innerValue);
  };

  var grid = fluid ? {
    md: 'auto'
  } : {
    sm: 12,
    md: 6
  };
  return ___EmotionJSX(Row, _extends({
    horizontalGap: 16
  }, fluid && {
    justify: 'space-between'
  }), label && ___EmotionJSX(Col, {
    sm: 12,
    md: 6
  }, ___EmotionJSX("p", null, label)), ___EmotionJSX(Col, _extends({}, grid, {
    displayFlex: true
  }), ___EmotionJSX(React.Fragment, null, ___EmotionJSX(CheckButton, {
    value: innerValue,
    onChange: handleChange
  }, "\u0414\u0430"), ___EmotionJSX("span", {
    className: "yes-no-separator"
  }), ___EmotionJSX(CheckButton, {
    value: !innerValue,
    onChange: handleChange
  }, "\u041D\u0435"))));
};

CheckboxSwitch.propTypes = {
  value: PropTypes.bool,
  fluid: PropTypes.bool,
  onChange: PropTypes.func,
  label: PropTypes.string,
  formId: PropTypes.string
};
export default CheckboxSwitch;